import { Component, Inject, Injector, Input, OnDestroy, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ButtonComponent, ConfirmComponent } from 'ui-library';

@Component({
    selector: 'terms-component',
    imports: [TranslateModule, ButtonComponent],
    templateUrl: 'terms.component.html',
    styleUrls: ['./terms.component.scss']
})

export class Terms implements OnDestroy {
    @Input() language: string = "fr-FR";
    data: any = {};
    isDialog: boolean = false;
    destroy$ = new Subject<void>();

    constructor(
        @Optional() public dialogRef: MatDialogRef<Terms>,
        @Optional() @Inject(MAT_DIALOG_DATA) public _data: any,
        private dialog: MatDialog,
        private injector: Injector) {
        if (_data) {
            this.isDialog = true;
            this.data = { ..._data };
            this.dialogRef = this.injector.get(MatDialogRef);
            this.language = this.data.language;
        } else {
            this.data.language = this.language;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    dismiss(): void {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '400px',
            data: {
                title: "Confirmation",
                content: "L'application Unifield ne peut pas être utilisée sans avoir accepté les Conditions Générales. Si vous confirmez, vous serez déconnectés."
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.ok) {
                this.dialogRef.close({ action: 'dismissed' });
            }
        });
    }

    confirm(): void {
        this.dialogRef.close({ action: 'confirm' });
    }
}